import { Link } from 'react-router-dom'
import { ROUTES } from '@/utils/constants'

export default function Footer() {
  const currentYear = new Date().getFullYear()

  return (
    <footer className="bg-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">PC Food Pantry</h3>
            <p className="text-gray-300">
              Providing free food, clothing, and household items to our community.
            </p>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to={ROUTES.ABOUT} className="text-gray-300 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to={ROUTES.GET_HELP} className="text-gray-300 hover:text-white transition-colors">
                  Get Help
                </Link>
              </li>
              <li>
                <Link to={ROUTES.VOLUNTEER} className="text-gray-300 hover:text-white transition-colors">
                  Volunteer
                </Link>
              </li>
              <li>
                <Link to={ROUTES.CONTACT} className="text-gray-300 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to={`${ROUTES.LOGIN}?next=${encodeURIComponent(ROUTES.ADMIN_TODAY)}`}
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  Staff Login
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link to={ROUTES.PRIVACY} className="text-gray-300 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to={ROUTES.TERMS} className="text-gray-300 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-300">
          <p>&copy; {currentYear} PC Food Pantry. All rights reserved.</p>
        </div>
      </div>
    <p style={{ margin: "1rem 0 0", padding: "0 1rem", textAlign: "center", fontSize: "0.875rem", flexBasis: "100%" }}><a href="https://blissits.com" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "underline", textUnderlineOffset: "0.2em" }}>Built by Bliss</a></p>
    </footer>
  )
}

